<template>
    <div class="rooms-container">
        <div v-for="(room, index) in product.Rooms" :key="room.Id">
            <Room :room="room" :roomNumber="index + 1" />
            <Divider
                v-if="index < product.Rooms.length - 1"
                color="lightGrey"
                bottomMargin="xxl"
                topMargin="xxl"
                thickness="1" />
        </div>
    </div>
</template>
<script lang="ts">
    import { defineComponent, PropType } from 'vue';
    import { HotelProduct } from '@/api/Cart/cart.interfaces';
    import Room from './Room/Room.vue';
    import Divider from '@ui/components/Divider/Divider.vue';

    export default defineComponent({
        name: 'HotelModalRooms',
        components: {
            Divider,
            Room,
        },
        props: {
            product: {
                type: Object as PropType<HotelProduct>,
                required: true,
            },
        },
    });
</script>

<style lang="scss" scoped>
    .rooms-container {
        width: 100%;
    }
</style>
